
export enum CarOfferProvider {
  carwow = 'carwow' // yep, just the one
}

export enum CarOfferFuelType {
  diesel = 'diesel',
  hybrid = 'hybrid',
  petrol = 'petrol',
  electric = 'electric'
}

export enum CarOfferDiscountType {
  percentage = 'percentage',
  absolute = 'absolute'
}

export enum CarOfferLeasingContractType {
  personal = 'personal',
  business = 'business'
}

export enum CarOfferWidgetType {
  find = 'find',
  buy = 'buy',
  lease = 'lease',
  buyOrLease = 'buyOrLease'
}
